import usePrivateAxios from '@/common/api/usePrivateAxios'
import { CompanyContractResponse, CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseCompanyContractProps = {
  id: string
}

type UseCompanyContractType = (props: UseCompanyContractProps) => UseQueryResult<CompanyContractType, unknown>

export const useCompanyContract: UseCompanyContractType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyContractResponse, unknown, CompanyContractType>({
    queryKey: ['clientContract', id],
    queryFn: () => {
      return privateAxios.get(`/client/contracts/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
